"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    externalFilename: v4_1.z.string().describe('External filename'),
    creditFacilitySlug: v4_1.z.string().describe('Credit facility slug'),
    encryptionConfig: finley_types_1.Util.EncryptionConfigSchema.optional().describe('Encryption config'),
    outputFileExtension: finley_types_1.Util.SupportedFileExtensionSchema.optional().describe('Explicit output file extension'),
    uploadConfig: tape_builder_base_1.RawCashUploadConfigSchema.optional().describe('Optional configuration for uploading a file on BBPL monitor.'),
});
exports.nodeType = 'file_rawCashBalanceFeed';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    externalFilename: true,
    creditFacilitySlug: true,
});
exports.artifactType = 'rawCashBalanceFeed';
//# sourceMappingURL=types.js.map